module.exports = __webpack_public_path__ + "img/orange.910990a0.png";